module.exports = __webpack_public_path__ + "img/finished.9f97fd43.svg";